export default "__VITE_ASSET__60515625__"